/**
 * qrPng — convierte el <svg> de react-qr-code en un PNG de alta resolución (fondo blanco, margen,
 * nombre debajo) listo para imprimir o compartir.
 */
const loadImage = (src) => new Promise((resolve, reject) => {
  const img = new Image();
  img.onload = () => resolve(img);
  img.onerror = reject;
  img.src = src;
});

export const svgToPngBlob = async (svgEl, { title = '', subtitle = '', size = 1024 } = {}) => {
  const xml = new XMLSerializer().serializeToString(svgEl);
  const svgUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(xml)}`;
  const img = await loadImage(svgUrl);
  const margin = Math.round(size * 0.08);
  const textH = (title ? Math.round(size * 0.1) : 0) + (subtitle ? Math.round(size * 0.06) : 0);
  const canvas = document.createElement('canvas');
  canvas.width = size + margin * 2;
  canvas.height = size + margin * 2 + textH;
  const ctx = canvas.getContext('2d');
  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, margin, margin, size, size);
  ctx.fillStyle = '#111111';
  ctx.textAlign = 'center';
  if (title) {
    ctx.font = `700 ${Math.round(size * 0.055)}px -apple-system, Helvetica, Arial, sans-serif`;
    ctx.fillText(title, canvas.width / 2, size + margin * 1.6);
  }
  if (subtitle) {
    ctx.font = `${Math.round(size * 0.035)}px -apple-system, Helvetica, Arial, sans-serif`;
    ctx.fillStyle = '#555555';
    ctx.fillText(subtitle, canvas.width / 2, size + margin * 1.6 + Math.round(size * 0.07));
  }
  return new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
};

export const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  setTimeout(() => URL.revokeObjectURL(url), 1500);
};
